export const CREATE_REVIEW_PARAM = 'new-review';
